module.exports = __webpack_public_path__ + "static/media/transparent_background_logo.791f4ee9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/decoration/img/transparent_background_logo.png
// module id = 316
// module chunks = 0